module.exports = __webpack_public_path__ + "img/step3.969cbde3.png";